import { HTTP } from "../../service/helper";

// initial state
const state = () => ({

});

// getters
const getters = {

};

// actions
const actions = {
    faqList(){
        return new Promise((resolve, reject) => {
            HTTP.get("/v1/faq-list")
              .then((response) => {
                 resolve(response);
              })
              .catch((error) => {
                 reject(error.response.data);
              });
        });
     },

     submitMessage(_,data){
        return new Promise((resolve, reject) => {

            HTTP.post("/v1/contactus",data)
               .then((response) => {
                  resolve(response);
               })
               .catch((error) => {
                  reject(error.response.data);
               });
         });
     },
};

// mutations
const mutations = {

};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
